import { IsString, MinLength, IsNotEmpty } from 'class-validator';

export class PersonPasswordRecoveryRequest {
    @IsString()
    @IsNotEmpty()
    public readonly code: string;

    @IsString()
    @MinLength(8)
    public readonly password: string;

    constructor(data?: Partial<PersonPasswordRecoveryRequest>) {
        this.code = data?.code;
        this.password = data?.password;
    }
}
